import script from "./button_basic.vue?vue&type=script&setup=true&lang=js"
export * from "./button_basic.vue?vue&type=script&setup=true&lang=js"

import "./button_basic.vue?vue&type=style&index=0&id=abbc36dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abbc36dc"]])

export default __exports__